import * as Sentry from "@sentry/react";
import moment from 'moment';
import Cookies from 'universal-cookie';
import config from '../config';
import { removeCookie } from "./cookies";
import errorCode from "../utils/errorsList.json";

export const authHeader = () => {
  const cookies = new Cookies();
  let token = cookies.get('user');

  if (token) {
    return { Authorization: 'Bearer ' + token };
  } else {
    return {};
  }
}

export const logout = () => {
  removeCookie('user');
  removeCookie('roles');
  removeCookie('email');
  removeCookie('branch_office_id');
  removeCookie('country_code');
  removeCookie('department_id');
  removeCookie('box_id');
  window.location.href = config.loginRedirect;
}

export const hasEditPermissions = () => {
  const cookies = new Cookies();
  const roles = cookies.get('roles');
  return (
    roles.includes('gerencia') ||
    roles.includes('comercial') ||
    roles.includes('super_usuario')
  );
}

const errorHandler = (response) => {
  let error;
  if ([400, 403, 404, 409, 422, 432, 500, 504].includes(response?.status)) {
    error = errorCode[response?.code] || response?.msg || response?.message || response?.statusText || 'Error';
    throw (error);
  } else if (response.status === 401 && process.env.NODE_ENV !== 'development') {
    logout();
    window.location.href = config.loginRedirect;
  } else {
    console.error('unhandled error', response);
    error = response?.msg || response?.message || response?.statusText || 'Error desconocido';
    throw (error);
  }
}

export const handleResponse = (response) =>
  response.text().then((text) => {
    let data = {};
    try {
      data = text && JSON.parse(text);
    } catch {
      data = text;
    }
    if (!response?.ok) {
      errorHandler({ status: response?.status, ...data });
    }
    return data === '' ? true : data;
  }).catch((error) => {
    Sentry.captureException(error);
    return Promise.reject(error);
  });

export const formatAmountByCurrency = (data) => {
  return new Intl.NumberFormat(data.countryCode, {
    style: 'currency',
    currency: data.currencyCode,
  }).format(data.amount);
};

export const returnToken = () => {
  const cookies = new Cookies();
  return cookies.get('user');
}

export const timeDiff = (from, to, timezone, format) => {
  moment.tz.setDefault(timezone)
  const fromTime = moment.tz(from, 'YYYY-MM-DDTHH:mm:ss', timezone);
  const toTime = to ? moment.tz(to, 'YYYY-MM-DDTHH:mm:ss', timezone) : moment().tz(timezone);
  let duration;
  if (format) {
    duration = moment.duration(toTime.diff(fromTime));
    duration = `${duration.hours() ? duration.hours() + 'h' : ''} ${duration.minutes()}m`;
  } else {
    duration = fromTime.from(toTime);
  }
  return duration;
};

export default handleResponse;
